import { Component, OnInit, AfterViewInit, ElementRef, ViewChildren } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ILoggedUser } from "../headerandnavigation/loggeduser/loggeduser";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { FormControlName, FormGroup, FormBuilder, Validators, AbstractControl } from "@angular/forms";
import { IChangePassword, IForceChangePassword, IUser } from "../users/user";
import { GenericValidator } from "../shared/generic-validator";
import { Observable } from "rxjs/Observable";
import { UserService } from "../users/user.service";
import { IAccount } from "../headerandnavigation/accounts/account";
import { LoaderService } from "../LoaderService";
declare var $: any;

@Component({
  templateUrl: "./home.component.html"
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  msgs = [];
  messages = [];
  loggedUser: ILoggedUser;
  user: IUser;
  account: IAccount;
  public pageTitle: string = 'Home';
  public showChangeForceChangePassword: boolean = true;

  changePasswordForm: FormGroup;
  changePassword: IChangePassword;
  displayMessageChangePassword: { [key: string]: string } = {};
  private validationMessagesChangePassword: { [key: string]: { [key: string]: string } };
  private genericValidatorChangePassword: GenericValidator;

  public teleganceClass = "disabled-box";
  public myServiceExpert = "disabled-box";
  public myDriveSafeExpert = "disabled-box";
  public milageCount = "disabled-box";

  public teleganceAd = "show";
  public myServiceExpertAd = "show";
  public myDriveSafeExpertAd = "show";
  public milageCountAd = "show";

  public showFuelCardAccount = "enable-box";
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public headerAndNavigationService: HeaderAndNavigationService,
    public userService: UserService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageName = this.pageTitle;
    this.appCommonService.pageContentAdditionalClass = "dashboard-page";
    this.validationMessagesChangePassword = {
      oldPassword: {
        required: 'Old Password is required.'
      },
      newPassword: {
        required: 'New Password is required.'
      },
      confirmPassword: {
        required: 'Confirm Password is required.'
      }
    };
    this.genericValidatorChangePassword = new GenericValidator(this.validationMessagesChangePassword);
  }

  ngOnInit() {
    //debugger
    this.headerAndNavigationService.showhideNav(true, false);

    if (this.loggedUser != null && this.loggedUser != undefined && this.loggedUser.id != undefined) {
      let accesAccounts = this.authService.getAccessAccounts();
      if (accesAccounts.length < 1) {
        this.authService.showLoader = true;
      }
    }

    this.changePasswordForm = this.fb.group({
      id: '',
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      //confirmPassword: ['', [Validators.required]]
      confirmPassword: ''
    });

    this.loggedUser = this.headerAndNavigationService.getLoggedUser();
    if (this.loggedUser != null && this.loggedUser != undefined) {
      if (this.loggedUser.id == null || this.loggedUser.id == undefined) {

        this.showFuelCardAccount = "disabled-box";
      }
    }
    //if (this.loggedUser != null && this.loggedUser.applications_access != null && this.loggedUser.applications_access != undefined) {
    //debugger
    let impId = localStorage.getItem(this.authService.mftImpersonationId)
    if (impId != undefined && impId != null) {
      let userData = JSON.parse(sessionStorage.getItem(("userDataImpersonate_EServicesExternalLocalhost")));
      if (userData == undefined) {
        userData = JSON.parse(sessionStorage.getItem(("userDataImpersonate_EServicesExternal")));
      }
      if (this.loggedUser != null) {
        if (userData == undefined && userData == null) {
          this.headerAndNavigationService.callImperaonateAuthenticateToken(this.authService.getUserToken(), impId)
            .subscribe(
              (token: any) => {
                this.headerAndNavigationService.updateUserInfoXRM(token._body)
                  .subscribe(
                    (data: any) => {
                      //debugger
                      var userData = JSON.parse(data._body);
                      sessionStorage.setItem("userDataImpersonate_" + this.authService.clientId, data._body);
                      var applications_accessArray = JSON.parse(userData.applications_access);
                      applications_accessArray.forEach(x => {
                        if (x == 1) {
                          this.milageCount = "enabled-box";
                          this.milageCountAd = "hide";
                        }
                        if (x == 2) {
                          this.teleganceClass = "enabled-box";
                          this.teleganceAd = "hide";
                        }
                        if (x == 3) {
                          this.myDriveSafeExpert = "enabled-box"
                          this.myDriveSafeExpertAd = "hide";
                        }
                        if (x == 4) {
                          this.myServiceExpert = "enabled-box"
                          this.myServiceExpertAd = "hide";
                        }


                      });
                    },
                    (error: any) => {

                    }
                  );
              },
              (error: any) => {

              }
            );
        }
        else {
          var applications_accessArray = JSON.parse(userData.applications_access);
          applications_accessArray.forEach(x => {
            if (x == 1) {
              this.milageCount = "enabled-box";
              this.milageCountAd = "hide";
            }
            if (x == 2) {
              this.teleganceClass = "enabled-box";
              this.teleganceAd = "hide";
            }
            if (x == 3) {
              this.myDriveSafeExpert = "enabled-box"
              this.myDriveSafeExpertAd = "hide";
            }
            if (x == 4) {
              this.myServiceExpert = "enabled-box"
              this.myServiceExpertAd = "hide";
            }


          });
        }

      }
    }
    else {
      if (this.loggedUser != null && this.loggedUser.applications_access != null && this.loggedUser.applications_access != undefined) {
        var applications_accessArray = JSON.parse("[" + this.loggedUser.applications_access + "]");
        applications_accessArray.forEach(x => {
          x.forEach(y => {
            if (y == 1) {
              this.milageCount = "enabled-box";
              this.milageCountAd = "hide";
            }
            if (y == 2) {
              this.teleganceClass = "enabled-box";
              this.teleganceAd = "hide";
            }
            if (y == 3) {
              this.myDriveSafeExpert = "enabled-box"
              this.myDriveSafeExpertAd = "hide";
            }
            if (y == 4) {
              this.myServiceExpert = "enabled-box"
              this.myServiceExpertAd = "hide";
            }
          })
        });
      }
    }
    //debugger;
    if (this.loggedUser == null) {
      this.headerAndNavigationService.RedirectToLogin();
    }
    this.account = this.authService.getFirstSelectedAccessAccount();
    this.userService.msgs = [];
    if (this.loggedUser.role == "Standard User") {
      this.checkStandardUserEnableForcePasswordChange();
    }
    else {
      this.showInitialPopUps();
    }
    //this.headerAndNavigationService.getLoggedUser()
    //.subscribe(
    //    (user:ILoggedUser) => {
    //      this.loggedUser = user;
    //      this.account = this.authService.getFirstSelectedAccessAccount();
    //      this.userService.msgs = [];
    //      if (this.loggedUser.role == "Standard User") {
    //        this.checkStandardUserEnableForcePasswordChange();
    //      }
    //      else {
    //        this.showInitialPopUps();
    //      }
    //    },
    //    (error: any) => {                
    //      this.headerAndNavigationService.showError("Logged user retrieval problem", <any>error);
    //      this.headerAndNavigationService.RedirectToLogin();
    //    }
    //);        
  }

  ngAfterViewInit() {
    // Watch for the blur event from any input element on the form.
    let controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

    // Merge the blur event observable with the valueChanges observable
    Observable.merge(this.changePasswordForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
      this.displayMessageChangePassword = this.genericValidatorChangePassword.processMessages(this.changePasswordForm);
    });

    const selfMe = this;
    $('#welcomeModal').on('hidden.bs.modal', function () {
      selfMe.userService.msgs = [];
      selfMe.closeWelcomeWindow();
    });

    $('#forcePasswordChangeModal').on('hidden.bs.modal', function () {
      selfMe.userService.msgs = [];
      selfMe.closePasswordChangeWindow();
    });
  }

  showInitialPopUps() {
    if (this.authService.checkShowChangePasswordMessage()) {
      if (this.loggedUser.forcePasswordChange && this.showChangeForceChangePassword) {
        $('#forcePasswordChangeModal').modal('show');
        this.authService.setShowChangePasswordMessage();
      }
      else if (this.loggedUser.displayWelcomeFlag) {
        $('#welcomeModal').modal('show');
      }
    }
  }

  checkStandardUserEnableForcePasswordChange() {
    this.authService.checkStandardUserEnableForcePasswordChange()
      .subscribe(
        (data: any) => {
          this.showChangeForceChangePassword = (data == "true");
          this.showInitialPopUps();
        },
        (error: any) => {
          this.userService.showError("Standard user password flag checking problem", <any>error, true);
        }
      );
  }

  closeWelcomeWindow() {
    $('#welcomeModal').modal('hide');
    //if (this.loggedUser.forcePasswordChange) {
    //  $('#forcePasswordChangeModal').modal('show');
    //}
    this.getUserForWelcomeFlag(this.loggedUser.id);
  }

  closePasswordChangeWindow() {
    $('#forcePasswordChangeModal').modal('hide');
    if (this.loggedUser.displayWelcomeFlag) {
      $('#welcomeModal').modal('show');
    }
  }

  changePasswordSubmit(): void {
    if (this.changePasswordForm.valid) {
      // Copy the form values over the product object values
      this.changePasswordForm.patchValue({
        id: this.loggedUser.id,
      });
      let p = Object.assign({}, this.changePassword, this.changePasswordForm.value);
      this.loaderService.display(true);
      this.userService.updateUserForcePassword(p)
        .subscribe(
          () => {
            this.getUser(this.loggedUser.id);
          },
          (error: any) => {
            this.loaderService.display(false);
            this.userService.showError("Change Password", <any>error, true);
          }
        );
    } else if (!this.changePasswordForm.dirty) {
      this.reSetChangePasswordForm();
      $('#forcePasswordChangeModal').modal('hide');
    }
  }

  reSetChangePasswordForm() {
    this.changePasswordForm.reset();
  }

  getUser(id: string): void {
    this.userService.getUser(id)
      .subscribe(
        (user: IUser) => {
          //user.displayWelcomeFlag = false;
          user.forcePasswordChange = false;
          user.email = (user.email !== null ? user.email.replace(" (duplicate email)", "") : "");
          this.saveUser(user);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.userService.showError("User retrieval problem", <any>error);
          this.headerAndNavigationService.RedirectToLogin();
        }
      );
  }

  getUserForWelcomeFlag(id: string): void {
    this.userService.updateWelcomeMessage(id)
      .subscribe(
        () => {

        },
        (error: any) => {
          this.userService.showError("Welcome flag update problem", <any>error, true);
        }
      );
  }

  saveUserForWelcomeFlag(user: IUser): void {
    this.userService.saveUser(user)
      .subscribe(
        () => {
          //this.userService.showSuccess("Welcome Flag", "Updated successfully.");
        },
        (error: any) => {
          this.userService.showError("User update problem", <any>error, true);
        }
      );
  }

  saveUser(user: IUser): void {
    //$('#forcePasswordChangeModal').modal('hide');
    //this.loaderService.display(false);
    //this.reSetChangePasswordForm();
    //this.userService.showSuccess("Change Password", "Password changed successfully.");

    this.userService.saveUser(user)
      .subscribe(
        () => {
          $('#forcePasswordChangeModal').modal('hide');
          this.loaderService.display(false);
          this.reSetChangePasswordForm();
          this.userService.showSuccess("Change Password", "Password changed successfully.");
        },
        (error: any) => {
          this.loaderService.display(false);
          this.userService.showError("User update problem", <any>error, true);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts